export const KEY = {
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    ESCAPE: 'Escape',
    TAB: 'Tab',
    SPACE: ' ',
    ENTER: 'Enter'
};
